import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type {
  MySubscriptionInformationParams,
  MySubscriptionInformationResponseData,
  StartSubscriptionServiceStatusParams,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const START_SUBSCRIPTION_SERVICE_STATUS_QUERY_KEY =
  'start_subscription_service_status';
export const MY_SUBSCRIPTION_INFORMATION_QUERY_KEY =
  'my_subscription_information';

export const useStartSubscriptionServiceStatus = ({
  fetchUrl,
  refetchOptions,
}: StartSubscriptionServiceStatusParams) => {
  return useQuery({
    queryKey: [START_SUBSCRIPTION_SERVICE_STATUS_QUERY_KEY, fetchUrl],
    queryFn: () => {
      if (!fetchUrl) return { data: null };
      return HttpClient.request<{ data?: unknown }>({
        method: 'GET',
        url: fetchUrl,
        params: {
          subscription_id: refetchOptions.subscription_id,
        },
      });
    },
    refetchOnWindowFocus: (query) => {
      if ((query.state.data as { data?: unknown })?.data) return false;
      return true;
    },
    placeholderData: undefined,
    enabled: !!fetchUrl,
    refetchInterval: (query) => {
      const { refetchCount, refetchInterval } = refetchOptions;
      if ((query.state.data as { data?: unknown })?.data) return false;
      return query.state.dataUpdateCount < refetchCount
        ? refetchInterval
        : false;
    },
  });
};

export const useMySubscriptionInformation = ({
  fetchUrl,
}: MySubscriptionInformationParams) =>
  useQuery({
    queryKey: [MY_SUBSCRIPTION_INFORMATION_QUERY_KEY, fetchUrl],
    queryFn: () =>
      HttpClient.request<MySubscriptionInformationResponseData>({
        method: 'GET',
        url: fetchUrl,
      }),
    refetchOnWindowFocus: true,
    placeholderData: keepPreviousData,
  });
